import { lazy, Suspense } from "react";
import { useLenis } from "lenis/react";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Ticker from "@/components/landing/Ticker";
import Manifesto from "@/components/landing/Manifesto";

// Below-the-fold sections are code-split so they don't bloat the initial bundle.
const FreeEntry = lazy(() => import("@/components/landing/FreeEntry"));
const Events = lazy(() => import("@/components/landing/Events"));
const Gallery = lazy(() => import("@/components/landing/Gallery"));
const InstaFeed = lazy(() => import("@/components/landing/InstaFeed"));
const PastShows = lazy(() => import("@/components/landing/PastShows"));
const Merch = lazy(() => import("@/components/landing/Merch"));
const Reserve = lazy(() => import("@/components/landing/Reserve"));
const Footer = lazy(() => import("@/components/landing/Footer"));

export default function LandingPage() {
  const lenis = useLenis();
  const scrollToReserve = () => {
    const el = document.getElementById("reserve");
    if (!el) return;
    if (lenis) lenis.scrollTo(el, { offset: -70 });
    else el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <main data-testid="landing-page" className="relative bg-background text-foreground">
      <Header onReserve={scrollToReserve} />
      <Hero onReserve={scrollToReserve} />
      <Ticker />
      <Manifesto />
      <Suspense fallback={null}>
        <FreeEntry />
        <Events onReserve={scrollToReserve} />
        <Gallery />
        <InstaFeed />
        <PastShows />
        <Merch />
        <Reserve />
        <Footer onReserve={scrollToReserve} />
      </Suspense>
    </main>
  );
}
